import { Fragment } from "react";
import Hero from "container/pricing/Hero";
import PageLayouts from "layouts/PageLayouts";
import Features from "container/pricing/Features";
import Trusted from "container/home/Trusted";
import FrequentlyAsked from "container/pricing/FrequentlyAsked";
import BuyProxies from "container/home/BuyProxies";

const Pricing = () => {
    return (
        <Fragment>
            <PageLayouts title="Pricing Plan">
                <Hero />
                <Features />
                <Trusted />
                <FrequentlyAsked />
                <BuyProxies />
            </PageLayouts>
        </Fragment>
    );
};

export default Pricing;